import React from 'react';
import { Table, Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import moment from 'moment';

const BrandDetails = (props) => {
  const { onClose, brands } = props;

  return (
    <>
      <div className="heading">
        <LeftOutlined
          className="back-btn"
          onClick={() => {
            onClose();
          }}
        />
        Brands Allocated
      </div>
      <div className="mt-60">
        <Table
          dataSource={brands}
          bordered
          pagination={false}
          columns={[
            {
              title: 'Brand SKU',
              key: 'brand',
              dataIndex: ['Company', 'name'],
            },
            {
              title: 'Allocated on',
              key: 'allocatedOn',
              dataIndex: 'created_at',
              render: (time) => moment(time).format('DD.MM.YYYY'),
            },
          ]}
        />
      </div>
      <div className="btn-container mt-40">
        <Button className="default-btn" onClick={onClose} block>
          Go Back
        </Button>
      </div>
    </>
  );
};

export default BrandDetails;
